export default __webpack_public_path__ + "0108e89c9003e8c14ea3c4e99b09653e.woff";